import React from 'react';
import { useTranslation } from 'react-i18next';
import { SampleDto } from '@src/types/types';
import { Image } from '@components/atoms/Image';
import { classNames } from '@utils/classNames.ts';

interface SampleHeaderProps {
  sample: SampleDto;
  className?: string;
}

export const SampleHeader: React.FC<SampleHeaderProps> = ({
  sample,
  className,
}) => {
  const { t } = useTranslation('component', { keyPrefix: 'sampleDetails' });

  return (
    <div
      className={classNames(
        'bg-grey2 rounded-xl p-6 flex flex-col md:flex-row print:flex-row justify-between md:items-center print:items-center',
        className,
      )}
    >
      <div className="flex md:items-center print:items-center space-x-4">
        {sample.productImage ? (
          <Image
            image={sample.productImage}
            alt={sample.productName}
            className="h-[52px] max-w-[52px] object-contain"
            sizes="52px"
            lazy={false}
          />
        ) : (
          <div className="h-[52px] w-[52px] bg-grey3light rounded-md"></div>
        )}
        <div className="flex flex-col">
          <h1 className="text-xl font-bold mb-1">{sample.productName}</h1>
          <p className="text-grey1 font-normal hidden md:block print:block">
            {t('sampleId')} {sample.code}
          </p>
        </div>
      </div>
      <p className="text-grey1 font-normal block md:hidden print:hidden mt-2 mb-4">
        {t('sampleId')} {sample.code}
      </p>
      <span className="bg-ivarioBlueWithWhite border-2 border-ivarioBlue text-ivarioBlue px-5 py-2 rounded-bonusLarge w-max">
        {t(`status.${sample.status}`)}
      </span>
    </div>
  );
};
